import React, { useEffect, useState } from 'react';
import TableComponent from "../../components/TableComponent/TableComponent";

const SurahInformation = () => {
    const [surahInfo,setSurahInfo] = useState([]);
    useEffect(() => {
        fetch('/assets/json/surahInfo.json')
            .then(response => response.json())
            .then(data => {
                setSurahInfo([...data]);
            });
    }, []);
    return (
        <div className="mt-5 mb-5">
            <div className="container">
                <TableComponent data={surahInfo} 
                    heading={["No", "Name", "Meaning", "Location", "No. Verses", "No. Ruku"]}
                    keyInfo={["number", "name", "meaning", "location", "verses", "ruku"]} 
                />
            </div>
        </div>
    );
};

export default SurahInformation;